import { Card, Flex } from 'antd';
import { FunctionComponent } from 'react';

interface CustomCardProps {
	title: string;
	children: React.ReactNode;
	className?: string;
	actionButton?: React.ReactNode;
}

const CustomCard: FunctionComponent<CustomCardProps> = ({ title, children, className, actionButton }) => {
	return (
		<Card className={`customCard ${className}`}>
			<Flex justify="space-between" align="center" className="p-3 p-md-4" style={{ borderBottom: '1px solid #eee' }}>
				<h5 className="mb-0" style={{ color: 'var(--primary)' }}>
					{title}
				</h5>

				{actionButton}
			</Flex>
			<div className="p-3 p-md-4">{children}</div>
		</Card>
	);
};

export default CustomCard;
